import React from 'react';
import { Modal, Form, Input, FormInstance } from 'antd';
import validateStyles from './index.module.less';

const ValidateModal = React.memo(
  ({
    visible,
    isSubmitting,
    onOk,
    form
  }: {
    visible: boolean;
    isSubmitting: boolean;
    onOk: () => void;
    form: FormInstance;
  }) => {
    return (
      <Modal
        title="身份验证"
        open={visible}
        onOk={onOk}
        closable={false}
        okText="确定"
        cancelButtonProps={{ style: { display: 'none' } }}
        okButtonProps={{
          style: { width: '100%', height: 40, fontSize: 16 },
          disabled: isSubmitting
        }}
        confirmLoading={isSubmitting}
        transitionName=""
        destroyOnHidden={false}
      >
        <div className={validateStyles.content}>
          <Form form={form} layout="vertical">
            <Form.Item
              name="idCard"
              rules={[
                { required: true, message: '请输入患者手机号后 6 位' },
                { pattern: /^\d{6}$/, message: '手机号后 6 位必须是数字' },
                { len: 6, message: '请输入手机号正确的后 6 位数字' },
              ]}
              shouldUpdate={false}
            >
              <Input
                placeholder="请输入患者手机号后6位"
                style={{ width: '100%' }}
                maxLength={6}
                disabled={isSubmitting}
              />
            </Form.Item>
          </Form>
        </div>
      </Modal>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.visible === nextProps.visible &&
      prevProps.isSubmitting === nextProps.isSubmitting &&
      prevProps.form === nextProps.form &&
      prevProps.onOk === nextProps.onOk
    );
  }
);

export default ValidateModal;
